import { render, staticRenderFns } from "./ReportOrderSumsPerCustomerPage.vue?vue&type=template&id=6bdd105b&scoped=true"
import script from "./ReportOrderSumsPerCustomerPage.vue?vue&type=script&lang=js"
export * from "./ReportOrderSumsPerCustomerPage.vue?vue&type=script&lang=js"
import style0 from "./ReportOrderSumsPerCustomerPage.vue?vue&type=style&index=0&id=6bdd105b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd105b",
  null
  
)

export default component.exports